import React, { type ElementRef, memo } from '../../lib/teact/teact';

import { APP_NAME, IS_LEGENDS_WALLET } from '../../config';
import buildClassName from '../../util/buildClassName';

import useLang from '../../hooks/useLang';

import Button from '../ui/Button';
import PasscodeHeader from '../ui/PasscodeHeader';
import Logo from './Logo';

import styles from './AppLocked.module.scss';

interface OwnProps {
  ref: ElementRef<HTMLDivElement>;
  innerContentTopPosition?: number;
  handleChangeSlideForBiometricAuth: NoneToVoidFunction;
}

function UnlockButtonSlide({
  ref,
  innerContentTopPosition = 0,
  handleChangeSlideForBiometricAuth,
}: OwnProps) {
  const lang = useLang();

  return (
    <div
      ref={ref}
      className={styles.innerContent}
      style={`--position-top: ${innerContentTopPosition}px;`}
    >
      {IS_LEGENDS_WALLET ? (
        <PasscodeHeader title={APP_NAME} subtitle={lang('Unlock your wallet to continue')} />
      ) : (
        <>
          <Logo />
          <span className={buildClassName(styles.title, 'brand-font')}>{APP_NAME}</span>
        </>
      )}
      <Button isPrimary onClick={handleChangeSlideForBiometricAuth}>
        {lang('Unlock')}
      </Button>
    </div>
  );
}

export default memo(UnlockButtonSlide);
